import React, { Component } from "react";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import "./style.scss";
import classNames from "classnames";
import Navigation from "../../svg-icons/navigation";
import Address from "../../svg-icons/address";
import ArrowForward from "../../svg-icons/arrow-forward.js";
import ArrowBack from "../../svg-icons/arrow-back";
import PlayButtonOutline from "../../svg-icons/play-button-outline.js";
import PlayButtonFill from "../../svg-icons/play-button-fill.js";
import Filter from "../../svg-icons/filter.js";
import Close from "../../svg-icons/close.js";
import AlertError from "../../svg-icons/alert-error.js";
import Delete from "../../svg-icons/delete.js";
import ShortArrow from "../../svg-icons/short-arrow.js";
import Edit from "../../svg-icons/edit";
import ExpandMore from "../../svg-icons/expand-more";
import ExpandLess from "../../svg-icons/expand-less";
import Cart from "../../svg-icons/cart";
import Report from "../../svg-icons/report";
import ArrowLeft from "../../svg-icons/arrow-left";
import ArrowRight from "../../svg-icons/arrow-right";
import Right from "../../svg-icons/right";
import Location from "../../svg-icons/location";
import Locate from "../../svg-icons/locate";
import Loading from "../../svg-icons/loading";
import Map from "../../svg-icons/map";
import Done from "../../svg-icons/done";
import Phone from "../../svg-icons/phone";
import Email from "../../svg-icons/email";
import Check from "../../svg-icons/check";
import ArrowTop from "../../svg-icons/arrow-top";
import Marker from "../../svg-icons/marker";
import Telephone from "../../svg-icons/telephone";
import ArrowLeftThin from "../../svg-icons/arrow-left-thin";
import ArrowRightThin from "../../svg-icons/arrow-right-thin";
import SwiperLeft from "../../svg-icons/swiper-left";
import SwiperRight from "../../svg-icons/swiper-right";
import Like from "../../svg-icons/like";
import Liked from "../../svg-icons/liked";
import videoPlayIcon from "../../svg-icons/videoPlay";
import RightBoldIcon from "../../svg-icons/right-bold";


const Icons = {
  Navigation,
  Address,
  ArrowTop,
  ArrowForward,
  ArrowBack,
  ArrowLeft,
  ArrowRight,
  ArrowLeftThin,
  ArrowRightThin,
  Right,
  PlayButtonOutline,
  PlayButtonFill,
  Filter,
  Close,
  AlertError,
  Delete,
  ShortArrow,
  Edit,
  ExpandMore,
  ExpandLess,
  Cart,
  Report,
  Location,
  Done,
  Phone,
  Email,
  Check,
  Marker,
  Telephone,
  SwiperLeft,
  SwiperRight,
  Like,
  Liked,
  videoPlayIcon,
  RightBoldIcon,
  Locate,
  Loading,
  Map
};

export default class Icon extends Component {
  render() {
    const { icon, className, size, colorScheme, onClick = () => {}, name, svg, role = "icon" } = this.props;

    if (icon && icon.useAsIcon) {
      return <img src={icon.src} alt={icon.alt} />;
    } else if (icon && icon.alt) {
      const iconClassName = classNames("icon", className, colorScheme, `${size ? "size-" + size : ""}`);

      return <RichText tag="span" field={{ value: icon.alt }} onClick={onClick} className={iconClassName} />;
    } else if (svg || name) {
      const iconClassName = classNames("icon", className, colorScheme, `${size ? "size-" + size : ""}`),
        iconSvg = svg;

      const SelectedIcon = name ? Icons[name] : "";
      return name ? (
        <span
          id={name}
          className={iconClassName}
          onClick={evt => {
            onClick(evt);
          }}
        >
          <SelectedIcon />
        </span>
      ) : (
        <span
          className={iconClassName}
          dangerouslySetInnerHTML={{
            __html: iconSvg
          }}
          onClick={evt => {
            onClick(evt);
          }}
          role={role}
        />
      );
    } else {
      return null;
    }
  }
}
